// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.label__fa6 {
  display: block;
  color: var(--ring-secondary-color);
  font-size: var(--ring-font-size-smaller);
  line-height: var(--ring-line-height-lowest);
  margin-bottom: calc(var(--ring-unit) * 0.5);
}

.tagsContainer__cc3 {
  display: flex;
  padding: calc(var(--ring-unit) / 4) calc(var(--ring-unit) / 2);
  border: calc(var(--ring-border-radius) / 4) solid var(--ring-borders-color);
  border-radius: calc(var(--ring-unit) / 2);
  cursor: pointer;
}

.dropdownContainer__cb4 {
  min-width: 100%;
}

.popupContainer__fc4 {
  margin-top: calc(var(--ring-unit) / 2);
  padding: var(--ring-unit);
  width: calc(var(--ring-unit) * 50);
  max-height: 350px;
}

.popupContainer__fc4 > div {
  margin-left: calc(var(--ring-unit) * -1.5);
  margin-bottom: var(--ring-unit);
}

.placeholder__ca2 {
  opacity: 0.6;
}

.checkboxContainer__b5e {
  display: flex;
  flex-direction: column;
  gap: var(--ring-unit);
  padding-left: calc(var(--ring-unit) * 2);
}

.titleContainer__f3e {
  display: flex;
  gap: var(--ring-unit);
  align-items: flex-start;
}
`, "",{"version":3,"sources":["webpack://./src/modules/applications/tools-filter/filter-dialog/fields/remote-environment-field/remote-environment-field.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,kCAAkC;EAClC,wCAAwC;EACxC,2CAA2C;EAC3C,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,8DAA8D;EAC9D,2EAA2E;EAC3E,yCAAyC;EACzC,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,sCAAsC;EACtC,yBAAyB;EACzB,kCAAkC;EAClC,iBAAiB;AACnB;;AAEA;EACE,0CAA0C;EAC1C,+BAA+B;AACjC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,uBAAuB;AACzB","sourcesContent":[".label {\n  display: block;\n  color: var(--ring-secondary-color);\n  font-size: var(--ring-font-size-smaller);\n  line-height: var(--ring-line-height-lowest);\n  margin-bottom: calc(var(--ring-unit) * 0.5);\n}\n\n.tagsContainer {\n  display: flex;\n  padding: calc(var(--ring-unit) / 4) calc(var(--ring-unit) / 2);\n  border: calc(var(--ring-border-radius) / 4) solid var(--ring-borders-color);\n  border-radius: calc(var(--ring-unit) / 2);\n  cursor: pointer;\n}\n\n.dropdownContainer {\n  min-width: 100%;\n}\n\n.popupContainer {\n  margin-top: calc(var(--ring-unit) / 2);\n  padding: var(--ring-unit);\n  width: calc(var(--ring-unit) * 50);\n  max-height: 350px;\n}\n\n.popupContainer > div {\n  margin-left: calc(var(--ring-unit) * -1.5);\n  margin-bottom: var(--ring-unit);\n}\n\n.placeholder {\n  opacity: 0.6;\n}\n\n.checkboxContainer {\n  display: flex;\n  flex-direction: column;\n  gap: var(--ring-unit);\n  padding-left: calc(var(--ring-unit) * 2);\n}\n\n.titleContainer {\n  display: flex;\n  gap: var(--ring-unit);\n  align-items: flex-start;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"label": `label__fa6`,
	"tagsContainer": `tagsContainer__cc3`,
	"dropdownContainer": `dropdownContainer__cb4`,
	"popupContainer": `popupContainer__fc4`,
	"placeholder": `placeholder__ca2`,
	"checkboxContainer": `checkboxContainer__b5e`,
	"titleContainer": `titleContainer__f3e`
};
export default ___CSS_LOADER_EXPORT___;
